import { Button } from 'react-bulma-components';
import { Link } from '@reach/router';
import React from 'react';

const GoToLink = ({ children, ...props }) => {
  if(props.to && typeof props.to === 'string'){
    return <Link to={props.to}>{children}</Link>
  }
  else {
    return <Button size="small" color="danger">{children}</Button>
  }
}

export default GoToLink;